import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import { useTranslation } from "react-i18next";
import {
  getTheme2MultiSelectCss,
  getTheme2SearchFilterFieldCss,
  getTheme2SearchFilterStatusFieldCss,
} from "utils/theme2MultiSelect";
import { getStickyStockTableStickyColumnCss } from "utils/reactTableTheme";

const SEARCH_INVENTORY_STATUS_PREFIX = "search-inventory-status";

const SEARCH_INVENTORY_PAGE_STYLES = (isTheme2) => `
  ${isTheme2 ? `
  .search-inventory-page.search-inventory-page--theme2 .search-inventory-table-card .card-body {
    padding: 15px;
    padding-top: 10px;
    padding-bottom: 0 !important;
  }
  ${getTheme2SearchFilterFieldCss({
    pageScopeSelector: ".search-inventory-page.search-inventory-page--theme2",
    filtersSelector: ".search-inventory-table-card .search-inventory-filters",
    rowClass: "search-inventory-filters-row",
    colClass: "search-inventory-filter-col",
  })}
  ${getTheme2SearchFilterStatusFieldCss({
    pageScopeSelector: ".search-inventory-page.search-inventory-page--theme2",
    filterColClass: "search-inventory-filter-col",
  })}
  .search-inventory-page.search-inventory-page--theme2 .search-inventory-filters-row {
    column-gap: 4px;
  }
  .search-inventory-page.search-inventory-page--theme2 .search-inventory-filter-col {
    padding-left: 4px;
    padding-right: 4px;
  }
  .search-inventory-page.search-inventory-page--theme2 .search-inventory-filter-col:first-child {
    padding-left: 0;
  }
  ${getTheme2MultiSelectCss({
    prefix: SEARCH_INVENTORY_STATUS_PREFIX,
    pageScopeSelector: ".search-inventory-page.search-inventory-page--theme2",
  })}
  ` : ""}
  .sticky-stock-table .rt-table {
    width: 100%;
    min-width: 100%;
    border-collapse: collapse;
  }
  .sticky-stock-table .rt-thead .rt-th:not(:last-child) {
    text-align: center !important;
  }
  .sticky-stock-table .rt-thead .rt-th:last-child {
    text-align: right !important;
  }
  .sticky-stock-table .rt-thead .rt-th:not(:last-child) .rt-resizable-header-content {
    text-align: center;
    width: 100%;
    box-sizing: border-box;
  }
  .sticky-stock-table .rt-thead .rt-th:not(:last-child).-cursor-pointer .rt-resizable-header-content {
    padding-right: 2em;
  }
  .sticky-stock-table .rt-thead .rt-th:last-child .rt-resizable-header-content {
    text-align: right;
    width: 100%;
  }
  .sticky-stock-table .rt-tbody .rt-td:not(:last-child) {
    text-align: center;
    vertical-align: middle;
  }
  .sticky-stock-table .rt-tbody .rt-td:last-child {
    text-align: right;
    vertical-align: middle;
  }
  .sticky-stock-table .rt-tbody .rt-td:not(:last-child) > * {
    max-width: 100%;
    min-width: 0;
  }
  ${getStickyStockTableStickyColumnCss()}
  .inventory-search-field {
    position: relative;
  }
  .inventory-search-field .form-control {
    padding-right: 2.35rem;
  }
  .inventory-search-field__icon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    font-size: 16px;
    opacity: 0.9;
  }
  .inventory-search-field__clear {
    pointer-events: auto;
    background: transparent;
    border: 0;
    padding: 0;
    cursor: pointer;
    opacity: 1;
    transition: color 0.15s ease;
  }
  .inventory-search-field__clear:focus {
    outline: none;
  }
  .white-content .inventory-search-field__icon {
    color: #64748b;
  }
  body:not(.white-content) .inventory-search-field__icon {
    color: rgba(255, 255, 255, 0.5);
  }
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-5px); }
    to { opacity: 1; transform: translateY(0); }
  }
  .search-inventory-card-header.card-header {
    padding-top: 2px;
    padding-bottom: 0;
  }
  .search-inventory-card-header h2,
  .search-inventory-card-header h4 {
    font-size: 16px !important;
    margin-top: 10px;
    margin-bottom: 0;
    line-height: 1.2;
  }
  .search-inventory-page:not(.search-inventory-page--theme2) .card .card-body {
    padding: 15px;
    padding-top: 10px;
    padding-bottom: 10px !important;
  }
  .search-inventory-page.search-inventory-page--theme2 .card .card-body {
    padding: 15px;
    padding-top: 10px;
    padding-bottom: 0 !important;
  }
`;

const SearchInventoryCards = ({ isTheme2, filters, table, title }) => {
  const { t } = useTranslation();
  const pageTitle = title ?? t("searchInventory.title");

  const titleHeader = (
    <CardHeader className="search-inventory-card-header">
      <h2 className="mb-0">{pageTitle}</h2>
    </CardHeader>
  );

  return (
    <>
      <style>{SEARCH_INVENTORY_PAGE_STYLES(isTheme2)}</style>
      {isTheme2 ? (
        <Card className="search-inventory-table-card">
          {titleHeader}
          <CardBody>
            <div className="search-inventory-filters">{filters}</div>
            {table}
          </CardBody>
        </Card>
      ) : (
        <>
          <Card>
            {titleHeader}
            <CardBody>{filters}</CardBody>
          </Card>
          <Card>
            <CardBody>{table}</CardBody>
          </Card>
        </>
      )}
    </>
  );
};

export default SearchInventoryCards;
